
export default {
    props: {
        error: {
            type: Object,
            default: () => ({ statusCode: 404, message: 'Page not found' }),
        },
    },
}
